import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import { setCreativeApiError } from "../../actions/app/creatives";
import PreloaderStepper from "../../components/Steppers/PreloaderStepper";

// Google Analytics module
import ReactGA from "react-ga";

// initialize react-ga module
ReactGA.initialize("UA-172736709-1");
ReactGA.pageview("/preloader");

const useStyles = makeStyles((theme) => ({
  route: {
    marginTop: theme.spacing(2),
    position: "relative",
    minHeight: "84vh"
  },
  stepper: {
    paddingTop: "6vh"
  }
}));

const Preloader = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCreativeApiError(new Error(), false));
  }, [dispatch]);

  return (
    <Container maxWidth="xl" className={classes.route}>
      {/* Back link + advertiser switcher rendered inside PreloaderStepper so they share one row */}
      <PreloaderStepper className={classes.stepper} />
    </Container>
  );
};

export default Preloader;
